var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInfoUser = function SvgIconInfoUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 10.5H14a2.333 2.333 0 0 0-2.333 2.333v30.334A2.333 2.333 0 0 0 14 45.5h28a2.333 2.333 0 0 0 2.333-2.333V12.833A2.333 2.333 0 0 0 42 10.5Z",
    fill: "#9EEED3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.26 28h-3.864a1.896 1.896 0 0 0 0 3.792h3.864a1.896 1.896 0 1 0 0-3.792ZM36.604 19.834H19.396a1.896 1.896 0 0 0 0 3.792h17.208a1.896 1.896 0 0 0 0-3.792Z",
    fill: "#CFFCEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.055 35.682a6.758 6.758 0 1 0 0-13.516 6.758 6.758 0 0 0 0 13.516ZM45.5 50.166H24.59a2.334 2.334 0 0 1-2.278-2.847c1.28-5.883 6.496-9.917 12.735-9.917 6.238 0 11.45 4.02 12.73 9.917a2.333 2.333 0 0 1-2.277 2.847Z",
    fill: "#15C480"
  })));
};
export default SvgIconInfoUser;